import { Button, Input, Modal, Select } from 'antd'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'

import Loader from '../../../pages/pages/loader'
import { getUserId } from '../../../helpers/auth'
import ServicesDropdown from '../../ServicesDropdown'
import { useUpdateCustomerTicketMutation } from '../../../redux/apis/customersManagement/tickets/customerTicketsApiSlice'

const EditTicket = ({ state, open, setOpen, record, customerId=null }) => {
  const [updateTicket, {isLoading, error, isSuccess}]= useUpdateCustomerTicketMutation() 


  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      status: record?.status || '',
      feedback: record?.feedback || '',
      customer: record.customer?.id,
      last_updated_by: getUserId()
    },

    validationSchema: Yup.object({
      status: Yup.string().required('Please Chosse Status'),
      feedback: Yup.string().required('Please Enter Feedback')
    }),
    onSubmit: async values => {
      const formData = new FormData()
      for (let key in values) {
        formData.append(key, values[key])
      }

      try {
        if (state === 'edit') {
          await updateTicket({
            data: formData,
            id:record?.id
          }).unwrap()
        }
      } catch (err) {
        console.error(err)
      }
    }
  })

  useEffect(() => {
    if (error?.data) {
      const errorMessages = Object.values(error.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    } 
  }, [error])

  useEffect(() => {
    if (isSuccess) {
      toast.success('Ticket Updated successfully!')
      setOpen(false)
    } 
  }, [isSuccess])

  return (
    <Modal
      className='customModal'
      open={open}
      title={`Edit Ticket`}
      onCancel={() => setOpen(false)}
      footer={[
        <Button key='back' onClick={() => setOpen(false)}>
          Cancel
        </Button>,
        <Button
          key='submit'
          type='primary'
          onClick={() => {
            if (Object.keys(validation.errors).length !== 0) {
              Object.keys(validation.errors).map(key => {
                toast.error(validation.errors[key])
              })
              return
            }
            validation.handleSubmit()
          }}
        >
          Submit
        </Button>
      ]}
    >
      <Loader isLoading={isLoading} />

      <div className=' mb-3'>
        <label className="form-label">Status</label>
        <br />
        <Select
          name='status'
          style={{
            width: '100%'
          }}
          defaultValue={validation.values.status}
          value={validation.values.status}
          onChange={e => validation.setFieldValue('status', e)}
          onBlur={validation.handleBlur}
          options={
            [
              { label: "Closed", value: "closed" },
              { label: "Open", value: "open" },
            ]
          }
        />
        {validation.touched.status &&
        validation.errors.status ? (
          <p className='text-danger'>{validation.errors.status}</p>
        ) : null}
      </div>
      <div className=' mb-3'>
        <label className="form-label">feedback</label>
        <Input
          type='text'
          name='feedback'
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          value={validation.values.feedback}
        />
        {validation.touched.feedback &&
        validation.errors.feedback ? (
          <p className='text-danger'>{validation.errors.feedback}</p>
        ) : null}
      </div>
    </Modal>
  )
}

export default EditTicket
